module.exports = __webpack_public_path__ + "img/audio.d79593f5.svg";